var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "TmHeader",
    { attrs: { open: _vm.open }, on: { toggle: _vm.toggleHandler } },
    [
      _c("TmLogo", { attrs: { slot: "logo" }, slot: "logo" }),
      _vm._v(" "),
      _c(
        "template",
        { slot: "links" },
        [
          _c("TmLink", { attrs: { icon: "home-small" } }, [
            _c("a", { attrs: { href: _vm.getDomain() } }, [
              _vm._v("T-Mobile Web")
            ])
          ]),
          _vm._v(" "),
          _c("TmLink", { attrs: { icon: "sms-small" } }, [
            _c("a", { attrs: { href: _vm.getDomain() + "/sms/closed.jsp" } }, [
              _c(
                "span",
                {
                  domProps: { textContent: _vm._s(_vm.$t("global.menu.sms")) }
                },
                [_vm._v("Send SMS")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("TmLink", { attrs: { icon: "cookies" } }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.t-mobile.cz/ochrana-udaju/zpracovani-cookies",
                  target: "_blank"
                }
              },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.cookies"))
                    }
                  },
                  [_vm._v("Cookies Policy")]
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "extra" },
        [
          _vm.isActiveLanguage("cs")
            ? _c("TmLink", { attrs: { icon: "internet-small" } }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.changeLanguage("en")
                      }
                    }
                  },
                  [_vm._v("English")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isActiveLanguage("en")
            ? _c("TmLink", { attrs: { icon: "internet-small" } }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.changeLanguage("cs")
                      }
                    }
                  },
                  [_vm._v("Česky")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.authenticated
            ? _c(
                "TmLink",
                { attrs: { icon: "internet-small" } },
                [
                  _c("router-link", { attrs: { to: "/login" } }, [
                    _c(
                      "span",
                      {
                        domProps: {
                          textContent: _vm._s(_vm.$t("global.menu.login"))
                        }
                      },
                      [_vm._v("Sign in")]
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authenticated
            ? _c(
                "TmLink",
                { attrs: { icon: "internet-small" } },
                [
                  _c("router-link", { attrs: { to: "/logout" } }, [
                    _c(
                      "span",
                      {
                        domProps: {
                          textContent: _vm._s(_vm.$t("global.menu.logout"))
                        }
                      },
                      [_vm._v("Sign out")]
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }